import { useRegisterSW } from 'virtual:pwa-register/react';
import { useState, useEffect } from 'react';
import './PWAUpdatePrompt.css';

export function PWAUpdatePrompt() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      // Check for updates every 60 minutes
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      }
    },
  });

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {/* Update available banner */}
      {needRefresh && (
        <div className="pwa-update-banner">
          <span>New version available</span>
          <button
            className="pwa-update-btn"
            onClick={() => updateServiceWorker(true)}
          >
            Update
          </button>
        </div>
      )}

      {/* Offline indicator */}
      {isOffline && (
        <div className="pwa-offline-badge">
          Offline
        </div>
      )}
    </>
  );
}

export default PWAUpdatePrompt;
